import React, { useEffect, useState } from 'react';
import { Modal, Form, Input, Row, Col, Select, Radio } from 'antd';
import {
  PRODUCT_FIELDS,
  DEFAULT_SERVER_STATUS,
  LICENSE_TYPES,
  BUNDLE_TYPES,
} from '../constants';

export default function ProductModal ({ visible, onCancel, onSave, initialData, products }) {
  const [form] = Form.useForm();
  const [serverResponse, setServerResponse] = useState(DEFAULT_SERVER_STATUS);
  const [productPicker, setProductPicker] = useState(false);

  useEffect(() => {
    if (visible) {
      setServerResponse(DEFAULT_SERVER_STATUS);
      if (initialData) {
        const bundleItems = initialData.bundles.map(item => Number(item.bundle_item.id));
        setProductPicker(initialData.is_bundled ?? false);
        form.setFieldsValue(initialData);
        form.setFieldValue('bundle_items', bundleItems);
        calculateOriginalPrice();
      } else {
        form.resetFields();
        form.setFieldValue('is_bundled', false);
        form.setFieldValue('bundle_items', []);
        form.setFieldValue('is_credit_memo', false);
        form.setFieldValue('is_taxable', true);
        setProductPicker(false);
      }
    }
  }, [initialData, form, visible]);
  
  const onFinish = async values => {
    const response = await onSave({ ...initialData, ...values });
    const { success, code } = response;
    setServerResponse({success, code, message: response.message});
    if (success && !response.message) {
      form.resetFields();
    }
  };

  const calculateOriginalPrice = () => {
    const isBundled = form.getFieldValue('is_bundled');
    let originalPrice = 0;
    if (isBundled) {
      const productPrices = products.map(p => ({id: Number(p.id), price: p.price, is_credit_memo: p.is_credit_memo}))
      const formItems = form.getFieldValue('bundle_items');
      formItems.map(item => {
        productPrices.map(p => {
          if (p.id === +item) {
            if (!p.is_credit_memo) {
              originalPrice += +p.price;
            } else {
              originalPrice -= +p.price;
            }
          }
        })
      });
    } else {
      originalPrice = form.getFieldValue('price');
    }
    form.setFieldValue('price', originalPrice.toFixed(2));
  }

  const onEdit = () => {
    setServerResponse(DEFAULT_SERVER_STATUS);
  }

  const formChanges = (_, values) => {
    setProductPicker(values.is_bundled ?? false);
    if (!values.is_bundled) {
      form.setFieldValue('bundle_items', []);
    }
    if (_.license_type) {
      if (+_.license_type === 4) {
        form.setFieldValue('is_taxable', false);
      } else {
        const isCreditMemo = form.getFieldValue('is_credit_memo');
        if (isCreditMemo) {
          form.setFieldValue('is_taxable', false);
        } else {
          form.setFieldValue('is_taxable', true);
        }
      }
    }
    if (_.is_credit_memo) {
      if (_.is_credit_memo === true) {
        form.setFieldValue('is_taxable', false);
      } else {
        const isServiceLicense = form.getFieldValue('license_type');
        if (+isServiceLicense === 4) {
          form.setFieldValue('is_taxable', false);
        } else {
          form.setFieldValue('is_taxable', true);
        }
      }
    }
  }

  const formInput = (fieldName) => {
    switch (fieldName) {
      case 'license_type': 
        return (
          <Select
            placeholder="Select a License type"
            notFoundContent="No License available"
            onChange={() => onEdit()}
            style={{ width: '100%'}}
            showSearch
            optionFilterProp='children'
          >
            {LICENSE_TYPES?.length > 0 && LICENSE_TYPES.map((c) => (
              <Select.Option key={c.label} value={c.value}>{c.label}</Select.Option>
            ))}
          </Select>
        );
      case 'is_bundled': 
      case 'is_taxable': 
      case 'is_credit_memo': 
        return (
          <Radio.Group
            options={BUNDLE_TYPES}
            onChange={() => onEdit()}
            optionType='button'
          />
        );
      default :
        return (
          <Input onChange={() => {onEdit()}} />
        );
    }
  }

  return (
    <Modal
      open={visible}
      onCancel={onCancel}
      title={(initialData && initialData.id) ? 'Edit Product' : 'Add Product'}
      onOk={() => form.submit()}
    >
      <Form
        form={form}
        name="product"
        layout="vertical"
        onFinish={onFinish}
        onValuesChange={formChanges}
        >
        <Row gutter={16}>
            {PRODUCT_FIELDS.map(field => {
              return (
              <Col
                  key={field.name}
                  xs={24}
                  sm={24}
                  md={12}
              >
                <Form.Item
                key={field.name}
                name={field.name}
                label={field.label}
                rules={field.rules}
                >
                { formInput(field.name) }
                </Form.Item>
              </Col>
              )
            })}
        </Row>
        {
          productPicker && (
            <Row gutter={16}>
              <Col
                  key='bundle_items'
                  xs={24}
                  sm={24}
                  md={24}
              >
                <Form.Item
                  key='bundle_items'
                  name='bundle_items'
                  label='Bundled Products'
                  rules={productPicker ? [{ required: true, message: 'Choose at least 1 product!' }]: []}
                >
                  <Select
                    placeholder="Choose the product(s)"
                    mode='tags'
                    value={form.getFieldValue('bundle_items')}
                    onChange={() => {onEdit(); calculateOriginalPrice()}}
                    style={{ width: '100%'}}
                    optionFilterProp='children'
                  >
                    {products.length > 0 && products.map((c) => {
                      if (!c.is_bundled) {
                        return <Select.Option key={c.id} value={Number(c.id)}>{c.name} ({c.sku})</Select.Option>
                      }
                    })}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
          )
        }
      </Form>
      {
        (!serverResponse.status && serverResponse.message) &&
        <div style={{textAlign: 'center'}}>
          <label style={{color: 'red'}}>{serverResponse.message} {serverResponse.code ? `(${serverResponse.code})` : ''}</label>
        </div>
      }
    </Modal>
  );
}
